<script setup lang="ts">
  definePageMeta({ layout: 'auth', path: '/login-with-code' })

  import AuthPageLayout from '@clientportal/auth-layer/components/organisms/AuthPageLayout.vue'

  import { useAuthPage } from '@clientportal/auth-layer/composables/useAuthPage'

  import { Screens } from '@common/auth-layer/types'

  import { useI18n } from 'vue-i18n'

  import { useHead } from 'nuxt/app'

  const { t } = useI18n()

  const { createChangeScreenHandler, handleLoginCallback } = useAuthPage()

  const handleChangeScreen = createChangeScreenHandler(Screens.LOGIN_WITH_SECURE_CODE)

  useHead({
    title: () => t('auth.titles.loginWithCode'),
    meta: [{ name: 'description', content: () => t('auth.descriptions.loginWithCode') }],
  })
</script>

<template>
  <AuthPageLayout
    :initial-page="Screens.LOGIN_WITH_SECURE_CODE"
    @login-callback="handleLoginCallback"
    @change-screen="handleChangeScreen"
  />
</template>

<style scoped></style>
